import { render, staticRenderFns } from "./legal-page.view.vue?vue&type=template&id=0063c166&"
import script from "./legal-page.view.vue?vue&type=script&lang=js&"
export * from "./legal-page.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports